import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import ReminderContainer from './ReminderContainer'


const ReminderRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><ReminderContainer></ReminderContainer></Provider>
}

ReminderRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default ReminderRoot
